<template>
    <rkm-form
        ref="Form"
    >

        <rkm-area
            title="Quantidade de faltas permitidas em viagens agendadas"
            type="fieldset"
        >
            <rkm-row>
                <rkm-col cols="6">

                    <rkm-form-input
                        label="Quantidade de faltas permitidas"
                        v-model="model.faltas"
                        :validations="validations.faltas"
                        number
                    />
                </rkm-col>

                <rkm-col cols="6">

                    <rkm-form-input
                        label="Período (meses)"
                        v-model="model.periodo"
                        :validations="validations.periodo"
                        :disabled="!model.faltas || model.faltas == 0"
                        number
                    />
                </rkm-col>
            </rkm-row>
        </rkm-area>

        <rkm-area
            title="Horário da saída obrigatório"
            type="fieldset"
        >
            <rkm-row>
                <rkm-col cols="auto">
                    <rkm-form-checkbox v-model="model.horarioSaida">
                        Altera a obrigatoriedade do campo Hora da Saída. Se ativo o campo é obrigatório na
                        funcionalidade "Agendar transporte" no módulo "Transporte de Paciente".
                    </rkm-form-checkbox>
                </rkm-col>
            </rkm-row>
        </rkm-area>

        <rkm-area
            title="Transporte de paciente por jornada"
            type="fieldset"
        >
            <rkm-row>
                <rkm-col cols="auto">
                    <rkm-form-checkbox v-model="model.agendarTransporteJornada">
                        O módulo "Transporte de Paciente" deve gerenciar agendamentos apenas para as jornadas
                        cadastradas na data específica.
                    </rkm-form-checkbox>
                </rkm-col>
            </rkm-row>
        </rkm-area>

        <rkm-area
            title="Veículo obrigatório"
            type="fieldset"
        >
            <rkm-row>
                <rkm-col cols="auto">
                    <rkm-form-checkbox v-model="model.veiculo">
                        Altera a obrigatoriedade do campo Veículo. Se ativo o campo é obrigatório na
                        funcionalidade "Agendar transporte" no módulo "Transporte de Paciente".
                    </rkm-form-checkbox>
                </rkm-col>
            </rkm-row>
        </rkm-area>

        <rkm-area
            title="Comprovante acompanhante"
            type="fieldset"
        >
            <rkm-row>
                <rkm-col cols="auto">
                    <rkm-form-checkbox v-model="model.comprovanteAcompanhante">
                        Se ativa, emite o comprovante de viagem para o acompanhante
                    </rkm-form-checkbox>
                </rkm-col>
            </rkm-row>
        </rkm-area>

        <rkm-area
            title="Dados acompanhante"
            type="fieldset"
        >
            <rkm-row>
                <rkm-col cols="auto">
                    <rkm-form-checkbox v-model="model.dadosAcompanhante">
                        Com o status ativo, exibe as informações dos acompanhantes.
                    </rkm-form-checkbox>
                </rkm-col>
            </rkm-row>
        </rkm-area>

        <rkm-area
            title="Campo livre"
            type="fieldset"
        >
            <rkm-row>
                <rkm-col cols="auto">
                    <rkm-form-checkbox v-model="model.campoLivre">
                        Se ativo, o acompanhante será de preenchimento livre.
                    </rkm-form-checkbox>
                </rkm-col>
            </rkm-row>
        </rkm-area>

        <rkm-area
            title="Mensagem de protocolo"
            type="fieldset"
        >
            <rkm-row>
                <rkm-col cols="12">

                    <rkm-text-editor
                        label="Mensagem"
                        v-model="model.mensagemProtocolo"
                        rows="4"
                        max-rows="4"
                    />
                </rkm-col>
            </rkm-row>
        </rkm-area>

        <rkm-area
            title="Campo de observação do paciente"
            type="fieldset"
        >
            <rkm-row>
                <rkm-col cols="auto">
                    <rkm-form-checkbox v-model="model.exibirObservacaoPaciente">
                        Se ativo, exibe na funcionalidade "Listagem de transporte agendado" o campo "Observação do Paciente" nas impressões simplificadas e completas.
                    </rkm-form-checkbox>
                </rkm-col>
            </rkm-row>
        </rkm-area>

        <rkm-area
            title="Observação do transporte"
            type="fieldset"
        >
            <rkm-row>
                <rkm-col cols="auto">
                    <rkm-form-checkbox v-model="model.exibirObservacaoTransporte">
                        Se ativo, o campo "Observação do transporte" será exibido na funcionalidade "Listagem de transporte agendado", bem como nas impressões simplificadas e completas.
                    </rkm-form-checkbox>
                </rkm-col>
            </rkm-row>
        </rkm-area>

        <rkm-area
            title="Bloquear agendamento de transporte retroativo"
            type="fieldset"
        >
            <rkm-row>
                <rkm-col cols="auto">
                    <rkm-form-checkbox v-model="model.bloqueiaAgendamentoRetroativo">
                        Se ativo, não será permitido agendar transporte com data retroativa.
                    </rkm-form-checkbox>
                </rkm-col>
            </rkm-row>
        </rkm-area>

        <BoxClassificacaoCadastro
            v-if="model.classificacaoCadastro"
            :model="model"
        />

        <BoxIntegracaoAplicativo
            v-if="model.integracaoAplicativo"
            :model="model"
        />
    </rkm-form>
</template>

<script>

// Components.
import BoxClassificacaoCadastro from '../classificacao-cadastro/Form'
import BoxIntegracaoAplicativo from '../integracao-aplicativo/Form'

// Mixins.
import { repository } from '@/mixins'

export default {
    components: { BoxClassificacaoCadastro, BoxIntegracaoAplicativo },
    created() {

        this.repositories = {
            exame: this.getConectaSusRepository('parametrizacao.exame'),
            procedimento: this.getConectaSusRepository('sigtap.procedimento'),
        }
    },
    computed: {
        validations() {

            return {
                faltas: { min_value: 1 },
                periodo: { min_value: 1, required: true },
            }
        },
    },
    mixins: [repository],
    props: {
        form: { type: Object, required: true },
        model: { type: Object, required: true },
        id: { type: Number },
    },
    watch: {
        'model.faltas' (faltas) {

            if (!faltas) {

                this.model.periodo = null
            }
        },
    }
}
</script>